import { ClientField, FieldType } from '../../../shared/types/appTypes';

// Frontend-only UI helpers
export interface FieldTypeOption {
  type: FieldType;
  label: string;
  icon: string;
  defaultValue: any;
}

export const FIELD_TYPE_OPTIONS: FieldTypeOption[] = [
  { type: 'shortText', label: 'Short Text', icon: 'TextFields', defaultValue: null },
  { type: 'longText', label: 'Long Text', icon: 'Notes', defaultValue: null },
  { type: 'number', label: 'Number', icon: 'Numbers', defaultValue: '' },
  { type: 'boolean', label: 'Yes/No', icon: 'ToggleOn', defaultValue: null },
  { type: 'address', label: 'Address', icon: 'Home', defaultValue: null },
  { type: 'date', label: 'Date', icon: 'CalendarMonth', defaultValue: null },
  { type: 'dateRange', label: 'Date Range', icon: 'DateRange', defaultValue: { start: null, end: null } },
  { type: 'time', label: 'Time', icon: 'Schedule', defaultValue: null },
  { type: 'timeRange', label: 'Time Range', icon: 'TimerOutlined', defaultValue: { start: null, end: null } },
  { type: 'multipleChoice', label: 'Multiple Choice', icon: 'FormatListBulleted', defaultValue: null },
  { type: 'imageChoice', label: 'Image Choice', icon: 'Image', defaultValue: null },
  { type: 'video', label: 'Video', icon: 'PlayCircle', defaultValue: '' },
  { type: 'appleMusicPlaylist', label: 'Apple Music Playlist', icon: 'MusicNote', defaultValue: [] },
];

export const getFieldTypeOption = (type: FieldType): FieldTypeOption | undefined => {
  return FIELD_TYPE_OPTIONS.find(opt => opt.type === type);
};

export const createDefaultField = (type: FieldType, order: number): ClientField => {
  const baseField = {
    label: 'New Field',
    question: '',
    helperText: '',
    finalized: false,
    modifiedAt: null as any, // Will be set on save
    modifiedBy: '',
    order,
  };

  switch (type) {
    case 'shortText':
      return { ...baseField, type: 'shortText', value: null };
    case 'longText':
      return { ...baseField, type: 'longText', value: null };
    case 'number':
      return { ...baseField, type: 'number', value: '' };
    case 'boolean':
      return { ...baseField, type: 'boolean', value: null };
    case 'address':
      return {
        ...baseField,
        type: 'address',
        value: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          state: '',
          postalCode: '',
          country: '',
        },
      };
    case 'date':
      return { ...baseField, type: 'date', value: null };
    case 'dateRange':
      return { ...baseField, type: 'dateRange', value: { start: null, end: null } };
    case 'time':
      return { ...baseField, type: 'time', value: null };
    case 'timeRange':
      return { ...baseField, type: 'timeRange', value: { start: null, end: null } };
    case 'multipleChoice':
      return {
        ...baseField,
        type: 'multipleChoice',
        choices: [],
        allowOtherChoice: false,
        checkAllThatApply: false,
        value: null,
      };
    case 'imageChoice':
      return { ...baseField, type: 'imageChoice', value: null, options: [] };
    case 'video':
      return {
        type: 'video',
        label: 'New Video',
        playbackUrl: '',
        order,
        modifiedAt: null as any,
        modifiedBy: '',
      };
    case 'appleMusicPlaylist':
      return {
        ...baseField,
        type: 'appleMusicPlaylist',
        playlistUrl: '',
        value: [],
      };
    default:
      return { ...baseField, type: 'shortText', value: null };
  }
};
